module.exports = __webpack_public_path__ + "img/insurance.ac79e876.svg";